import React, { useState, useEffect, useRef, useCallback } from "react";
import Modal from "react-modal";
import MenuHeader from "./MenuHeader";
import BookingService from "../services/booking.service";
import RatingService from "../services/rating.service";
import useApi from "../hooks/useApi";
import useAuth from "../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import Rating from "@mui/material/Rating";
import { addressFormat } from "../shared/utils/string";
import { styled } from "@mui/material/styles";
import star2 from '../assets/images/star2.svg';
import CommandeEdit from './CommandeEdit';
import { useNotifications } from '../context/NotificationProvider';
import { Button, Container, createTheme, IconButton, ThemeProvider } from '@mui/material';
import { useLoading } from '../context/LoadingProvider';
import { useTranslation } from 'react-i18next';
import ProductService from "../services/product.service";
import CloseIcon from '@mui/icons-material/Close';
import CalendarManagementService from "../services/calendar_management.service";
import { useTranslatableData } from "../hooks/useTranslatable";
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";
import { createEventDedupeKey, normalizeMoneyValue, pushDataLayerEvent } from "../utils/gtmDataLayer";
import {
  buildEcommerceObject,
  buildItemsFromBooking,
  buildUserDataObject,
  computeTaxFromTtc,
  extractPaymentMethodFromTransactions,
  resolveBookingTransactionId,
} from "../utils/gtmEcommerce";
import { buildGtmEventFields } from "../utils/gtmEventFields";


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    boxshadow: '0 0 10px rgba(0, 0, 0, 0.5)',
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    height: 'auto',
    width: '400px',
    borderRadius: '10px',
    padding: '20px',
  },
};

const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const theme = createTheme({
  palette: {
    white: {
      "main": "#FFFFFF",
      "light": "#FFFFFF",
      "dark": "#FFFFFF",
      "contrastText": "#FFFFFF"
    },
    dark_yellow: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FAEF9B",
    },
    dark_white: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FFFFFF",
    },
    dark: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#393D44"
    }
  },
});

const CustomRating = styled(Rating)({
  "& .MuiRating-iconEmpty": {
    opacity: 0.8,
    color: '#faef9b',
  },
  "& .MuiRating-icon": {
    width: "30px",
    height: "30px",
    margin: "0 10px",
  },
});

function getExtendedEndTime(startBeforeISO, durationMin) {
  if (!startBeforeISO || !durationMin) return null;

  try {
    const start = new Date(startBeforeISO);
    return new Date(start.getTime() + durationMin * 60000);
  } catch (e) {
    console.error("getExtendedEndTime error:", e);
    return null;
  }
}

function Commande() {
  const api = useApi();
  const { auth } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState(null);
  const [rating, setRating] = useState(5); // Default rating to 5
  const [comment, setComment] = useState("");
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
  const notify = useNotifications();
  const [isEditing, setIsEditing] = useState(false);
  const [bookingToEdit, setBookingToEdit] = useState(null);
  const { t, i18n } = useTranslation('commande');
  const navigate = useNavigate();
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [cancelMessage, setCancelMessage] = useState("");
  const [cancelSuccessMessage, setCancelSuccessMessage] = useState("");
  const [cancelBookingId, setCancelBookingId] = useState(null);
  const [diffInHour, setDiffInHour] = useState(null);
  const [cancelChoicePhase, setCancelChoicePhase] = useState(false);
  const [showOfflineConfirmation, setShowOfflineConfirmation] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [combinedBookings, setCombinedBookings] = useState([]);
  const [showProlongationModal, setShowProlongationModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProductToAdd, setSelectedProductToAdd] = useState(null);
  const [extendedEndTime, setExtendedEndTime] = useState(null);
  const [isProcessingChange, setIsProcessingChange] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [prolongationErrorMessage, setProlongationErrorMessage] = useState("");
  const [originalEndTime, setOriginalEndTime] = useState(null);
  const [modalIsPaiementOpen, setModalIsPaiementOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const bookings = useTranslatableData(combinedBookings);
  const PAGE_SIZE = 10;
  const didInitRef = useRef(false);
  const editRefreshNonceRef = useRef(0);
  const [editRefreshNonce, setEditRefreshNonce] = useState(0);
  const refreshingIdsRef = useRef(new Set());
  const mountedRef = useRef(true);
  const pendingListRefreshRef = useRef(false);
  const requestBookingsRefreshRef = useRef(null);
  const ordersChangedHandlerRef = useRef(null);

  const openModalPaiement = (message) => {
    setModalMessage(message);
    setModalIsPaiementOpen(true);
  };

  const closeModalPaiement = () => {
    setModalIsPaiementOpen(false);
  };

  const redirectToHome = () => {
    // si tu utilises react-router
    navigate('/');
    setModalIsPaiementOpen(false);
  };

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const normalizePayload = (data) => {
    if (!data) return {};
    if (typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (_) {
        return {};
      }
    }
    return data;
  };

  const extractBookingId = (payload) => {
    const raw = payload?.booking_id ?? payload?.id;
    if (Number.isInteger(raw)) return raw;
    if (typeof raw === "string") {
      const parsed = parseInt(raw, 10);
      return Number.isNaN(parsed) ? null : parsed;
    }
    return null;
  };

  const isFailedPayment = (status) => {
    if (!status) return false;
    return status.toString().toUpperCase() === "FAILED_PAYMENT";
  };

  const applyBookingUpdate = useCallback((updatedBooking, action = "updated") => {
    if (!updatedBooking?.id) return;

    setCombinedBookings((prev) => {
      let next = prev.filter((b) => b.id !== updatedBooking.id);
      if (action === "deleted" || isFailedPayment(updatedBooking.status)) {
        return sortBookings(next);
      }
      next = [...next, updatedBooking];
      return sortBookings(next);
    });

    setSelectedBooking((prev) =>
      prev?.id === updatedBooking.id ? updatedBooking : prev
    );

    if (bookingToEdit?.id === updatedBooking.id) {
      setBookingToEdit(updatedBooking);
      editRefreshNonceRef.current += 1;
      setEditRefreshNonce(editRefreshNonceRef.current);
      notify.info("Booking updated. Edit form refreshed.");
    }
  }, [bookingToEdit?.id, notify]);

  const removeBookingById = useCallback((bookingId) => {
    if (!bookingId) return;
    setCombinedBookings((prev) => prev.filter((b) => b.id !== bookingId));
    setSelectedBooking((prev) => (prev?.id === bookingId ? null : prev));
    if (bookingToEdit?.id === bookingId) {
      setBookingToEdit(null);
      setIsEditing(false);
      notify.warn("Booking deleted. Edit view closed.");
    }
  }, [bookingToEdit?.id, notify]);

  const addMinutesToTime = (time, duration) => {
    const [hours, minutes] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes + duration);

    return date.toLocaleTimeString(i18n.language === 'fr' ? 'fr-FR' : 'en-US', { hour: '2-digit', minute: '2-digit' });
  };

  const fetchBookings = async (pageNum = 1, options = {}) => {
    const { force = false } = options;
    if (loading) {
      if (force) {
        pendingListRefreshRef.current = true;
      }
      return;
    }
    setLoading(true);
    try {
      const response = await BookingService.index({
        with: 'address,therapists.media,therapists.categories,client,products.category,ratings,hotel,transactions',
        client_id: `${auth?.user ? auth.user.id : -1}`,
        sort: '-start_before',
        id: id ? `in:${id}` : "",
        page: pageNum,
        per_page: PAGE_SIZE // Load 10 at a time
      }, api);

      const filteredData = response.data.filter(
        booking => booking.status !== "FAILED_PAYMENT"
      );

      const sortedData = filteredData.sort((a, b) => {
        const excludedStatuses = ['CANCELED', 'COMPLETED', 'FAILED'];
        const aLater = excludedStatuses.includes(a.status);
        const bLater = excludedStatuses.includes(b.status);
        if ((aLater && bLater) || (!aLater && !bLater)) {
          return new Date(a.start_before) - new Date(b.start_before);
        }
        return !aLater && bLater ? -1 : 1;
      });

      if (pageNum === 1) {
        setCombinedBookings(sortedData);
      } else {
        setCombinedBookings(prev => [...prev, ...sortedData]);
      }

      setPage(pageNum + 1);
      setHasMore(response.data.length === PAGE_SIZE);

    } catch (error) {
      console.error("Error fetching bookings:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
      if (pendingListRefreshRef.current) {
        pendingListRefreshRef.current = false;
        fetchBookings(1, { force: true });
      }
    }
  };

  requestBookingsRefreshRef.current = () => {
    if (loading) {
      pendingListRefreshRef.current = true;
      return;
    }
    fetchBookings(1, { force: true });
  };

  const fetchBookingById = useCallback(async (bookingId) => {
    if (!bookingId) return;
    if (refreshingIdsRef.current.has(bookingId)) return;
    refreshingIdsRef.current.add(bookingId);

    try {
      const response = await BookingService.index({
        with: 'address,therapists.media,therapists.categories,client,products.category,ratings,hotel,transactions',
        client_id: `${auth?.user ? auth.user.id : -1}`,
        id: `in:${bookingId}`,
        per_page: 1,
      }, api);

      const list = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      const updated = list[0];
      if (updated && mountedRef.current) {
        applyBookingUpdate(updated);
        return;
      }
      if (mountedRef.current) {
        requestBookingsRefreshRef.current?.();
      }
    } catch (error) {
      console.error("Realtime booking fetch failed:", error);
    } finally {
      refreshingIdsRef.current.delete(bookingId);
    }
  }, [api, auth?.user, applyBookingUpdate]);

  useEffect(() => {
    ordersChangedHandlerRef.current = (data) => {
      const payload = normalizePayload(data);
      const bookingId = extractBookingId(payload);
      const action =
        payload?.action ? payload.action.toString().toLowerCase() : "updated";

      if (action === "deleted" && bookingId) {
        removeBookingById(bookingId);
        requestBookingsRefreshRef.current?.();
        return;
      }

      if (bookingId) {
        fetchBookingById(bookingId);
      }

      requestBookingsRefreshRef.current?.();
    };
  }, [fetchBookingById, removeBookingById]);

  useEffect(() => {
    const userId = auth?.user?.id;
    if (!userId) return;

    initPusher({ token: auth?.accessToken });

    const channel = `private-user.${userId}`;
    const handler = (data) => {
      ordersChangedHandlerRef.current?.(data);
    };
    const unbind = bindEvent(channel, "orders.changed", handler);

    return () => {
      unbind();
    };
  }, [auth?.user?.id, auth?.accessToken]);

  useEffect(() => {
    const userId = auth?.user?.id;
    if (!userId) return;

    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      requestBookingsRefreshRef.current?.();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.user?.id, auth?.accessToken]);

  useEffect(() => {
    const handleOnline = () => {
      requestBookingsRefreshRef.current?.();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  // useEffect(() => {
  //   fetchBookings(); // Initial load
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (loading || !hasMore || isEditing) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 200) {
        fetchBookings(page);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore, page]);

  const formatDate = (date, lang) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString(lang, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'Europe/Zurich'
    });
  };

  const formatTime = (date, lang) => {
    if (!date) return '';
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Zurich'
    };

    if (lang === 'fr') {
      options.hour12 = false;
      return new Date(date).toLocaleTimeString('fr-FR', options).replace(':', 'h');
    } else {
      options.hour12 = true;
      return new Date(date).toLocaleTimeString('en-US', options);
    }
  };


  const formatSelectedDate = (date) => {
    const options = { month: 'short', day: 'numeric' };
    return new Intl.DateTimeFormat(i18n.language === 'fr' ? 'fr-FR' : 'en-US', options).format(new Date(date));
  };

  const formatHistoryCardDate = (date) => {
    if (!date) return '';

    return new Intl.DateTimeFormat(i18n.language === 'fr' ? 'fr-FR' : 'en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'Europe/Zurich',
    }).format(new Date(date));
  };

  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    fetchBookings(1);
  }, [])

  const openModal = (therapist, bookingId) => {
    setSelectedTherapist(therapist);
    setSelectedBookingId(bookingId);
    setRating(5); // Default to 5 stars
    setComment("");
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setRating(5); // Reset to default 5 stars
    setComment("");
  };

  const fetchCalendarData = async (therapist, date) => {
    try {
      const response = await CalendarManagementService.index(
        {
          date: new Date(date).toLocaleDateString('en-CA').split('T')[0],
          therapist_id: therapist.id,
          with: 'therapist.media,therapist.zones,calendars_managements_slots.slot',
        },
        api,
        auth?.accessToken ? false : true
      );
      console.log('response calendrier :', response);
      return response



    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  };
  const handlePayment = async (booking) => {
    if (booking?.status === "PROCESSING_PAYMENT") {
      return;
    }

    console.log('Booking:', booking);

    // Pour stocker la liste des flypro non disponibles
    let therapistBlocked = false;

    const bookingDateTime = new Date(booking.date); // ISO string
    const now = new Date();

    console.log(`Rendez-vous prévu le : ${bookingDateTime.toISOString()}`);
    console.log(`Date actuelle : ${now.toISOString()}`);

    if (bookingDateTime < now) {
      const response = await BookingService.update(booking.id, { locale: i18n.language }, api);
      console.log({ response });
      loadLightbox(response.data.transaction_data.payment_lightbox, response.data.transaction_data.payment_url);
      return;
    }

    // On boucle sur chaque flypro
    for (const therapist of booking.therapists) {
      console.log(`Vérification du flypro ${therapist.firstname} ${therapist.lastname}`);

      // Récupérer son calendrier
      const calendar = await fetchCalendarData(therapist, booking.date);
      console.log('calendar', calendar)
      // Début et fin du rendez-vous
      const start = new Date(booking.date);
      const end = new Date(start.getTime() + booking.duration * 60000);
      const bookingDate = start.toISOString().split('T')[0];

      console.log(`Rendez-vous prévu du ${start.toISOString()} au ${end.toISOString()}`);

      // Chercher les slots pour ce jour
      const dayCalendars = calendar?.filter(c => c.date.startsWith(bookingDate));
      if (!dayCalendars || dayCalendars.length === 0) {
        openModalPaiement(t('therapist_unavailable_message'));
        therapistBlocked = true;
        break;
      }

      // Parcourir les slots
      let slotFound = false;

      dayCalendars.forEach(cal => {
        cal.calendars_managements_slots.forEach(slot => {
          if (slot.status !== 'AVAILABLE') return;

          const [hourStart, minStart] = slot.slot.start_time.split(':').map(Number);
          const [hourEnd, minEnd] = slot.slot.end_time.split(':').map(Number);

          const slotStart = new Date(bookingDate + 'T' + slot.slot.start_time + ':00Z');
          slotStart.setUTCHours(hourStart, minStart, 0, 0);

          const slotEnd = new Date(bookingDate + 'T' + slot.slot.end_time + ':00Z');
          slotEnd.setUTCHours(hourEnd, minEnd, 0, 0);

          console.log(`Slot disponible de ${slotStart.toISOString()} à ${slotEnd.toISOString()}`);

          if (start >= slotStart && end <= slotEnd) {
            slotFound = true;
          }
        });
      });

      if (!slotFound) {
        openModalPaiement(t('therapist_unavailable_message'));
        therapistBlocked = true;
        break;
      }
    }

    if (therapistBlocked) {
      console.warn("Paiement bloqué car au moins un flypro n'a pas de créneau libre.");
      return;
    }

    // Si tous les flypro sont OK
    console.log("Tous les flypro sont disponibles, on lance le paiement.");

    const response = await BookingService.update(booking.id, { locale: i18n.language }, api);
    console.log({ response });
    loadLightbox(response.data.transaction_data.payment_lightbox, response.data.transaction_data.payment_url);
  };



  const loader = useLoading();

  const loadUrl = (paymentUrl) => {
    window.location.replace(paymentUrl);
  }
  const loadLightbox = (paymentLightboxScript, paymentUrl) => {
    loader.start();
    const script = document.createElement('script');
    script.src = paymentLightboxScript;
    script.async = true;
    script.onload = () => {
      window.LightboxCheckoutHandler.startPayment(null, () => { loader.stop(); loadUrl(paymentUrl) });
    };
    document.body.appendChild(script);
  }


  const handleSubmitReview = async (e) => {
    e.preventDefault();

    const formData = {
      rating,
      comment,
      therapist_id: selectedTherapist?.id,
      booking_id: selectedBookingId,
    };
    console.log({ formData })
    try {
      await RatingService.store(formData, api);
      if (rating === 5) {
        window.open("https://search.google.com/local/writereview?placeid=ChIJ_3bGeS4ujEcR_TyBfpQZPPk", "_blank");
      }
      setModalIsOpen(false);
      setSuccessModalIsOpen(true);
      fetchBookings();
    } catch (error) {
      console.error("Failed to submit review:", error);
    }
  };

  const handleCancelBooking = async (option) => {
    if (!option) option = 'FULL_REFUND';
    const previousBooking = combinedBookings.find((booking) => booking.id === cancelBookingId) || null;

    try {
      const response = await BookingService.cancel(
        cancelBookingId,
        api,
        { params: { option } }
      );
      await fetchBookings();
      setShowCancelConfirm(false);


      console.log("data cancel", response.data)

      const { refundType, promoCode } = response.data || {};
      if ((refundType === 'FULL_REFUND' || refundType === 'FLATT_OFF') && diffInHour >= 24 && diffInHour <= 120) {
        setCancelSuccessMessage(t('cancel_message_r'));
      } else {
        setCancelSuccessMessage(t('cancel_message_f'))
      }
      setShowCancelConfirm(true);
      void trackRefundEventIfNeeded({
        bookingId: cancelBookingId,
        previousBooking,
      });

    } catch (err) {

    }
  };

  const handleOfflinePaymentCancel = async () => {
    const previousBooking = combinedBookings.find((booking) => booking.id === cancelBookingId) || null;
    try {
      const response = await BookingService.cancel(
        cancelBookingId,
        api,
        { params: { option: 'FULL_REFUND' } }
      );
      await fetchBookings();
      setShowCancelConfirm(false);
      setShowOfflineConfirmation(false);

      console.log("offline payment cancel", response.data);

      setCancelSuccessMessage(t('offline_cancel_success_message', 'Votre commande a été annulée avec succès. Aucun remboursement automatique n\'a été effectué.'));
      setShowCancelConfirm(true);
      void trackRefundEventIfNeeded({
        bookingId: cancelBookingId,
        previousBooking,
      });

    } catch (err) {
      console.error("Error cancelling offline payment booking:", err);
    }
  };

  const hasOnlineTransactions = (booking) => {
    // Check if booking has transaction history or recent online payments
    console.log('Checking online transactions for booking:', {
      id: booking.id,
      total_fare: booking.total_fare,
      offline_payment: booking.offline_payment,
      transactions: booking.transactions
    });
    if (booking.transactions && Array.isArray(booking.transactions)) {
      return booking.transactions.some(transaction => 
        (transaction.succeeded_at !== null && transaction.succeeded_at !== undefined) ||
        ['COMPLETED', 'CONFIRMED', 'FULFILL'].includes(transaction.status)
      );
    }
    return false;
  };

  const extractBookingFromResponse = (response) => {
    if (Array.isArray(response)) return response[0] || null;
    if (Array.isArray(response?.data)) return response.data[0] || null;
    if (Array.isArray(response?.data?.data)) return response.data.data[0] || null;
    if (response?.id) return response;
    if (response?.data?.id) return response.data;
    return null;
  };

  const getRefundedTotal = (booking) =>
    normalizeMoneyValue(
      (Array.isArray(booking?.transactions) ? booking.transactions : []).reduce((sum, transaction) => {
        const refunded = Number(transaction?.refunded);
        return Number.isFinite(refunded) ? sum + refunded : sum;
      }, 0)
    ) || 0;

  const fetchBookingForTracking = async (bookingId) => {
    if (!bookingId) return null;
    try {
      const response = await BookingService.index(
        {
          with: "address,address.hotel,products.category,products.domain,hotel,transactions,client",
          client_id: `${auth?.user ? auth.user.id : -1}`,
          id: `in:${bookingId}`,
          per_page: 1,
        },
        api
      );

      return extractBookingFromResponse(response);
    } catch (_) {
      return null;
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const trackRefundEventIfNeeded = async ({ bookingId, previousBooking }) => {
    if (!bookingId) return;

    const refundedBefore = getRefundedTotal(previousBooking);

    for (let attempt = 0; attempt < 3; attempt += 1) {
      const latestBooking = await fetchBookingForTracking(bookingId);
      const refundedAfter = getRefundedTotal(latestBooking);
      const refundedDelta = normalizeMoneyValue(refundedAfter - refundedBefore) || 0;

      if (refundedDelta > 0) {
        const trackingBooking = latestBooking || previousBooking;
        const items = buildItemsFromBooking(trackingBooking, { booking: trackingBooking });
        if (!items.length) return;

        const paymentMethod = extractPaymentMethodFromTransactions(trackingBooking?.transactions);
        const currency =
          (Array.isArray(trackingBooking?.transactions) && trackingBooking.transactions[0]?.currency) || "CHF";
        const transactionId = resolveBookingTransactionId(trackingBooking, bookingId);
        const refundUserData = buildUserDataObject({
          user: auth?.user,
          client: trackingBooking?.client,
          booking: trackingBooking,
          address: trackingBooking?.address,
          phoneNumber: trackingBooking?.phone || auth?.user?.phone,
          emailAddress: trackingBooking?.client?.email || auth?.user?.email,
          isConnectedUser: Boolean(auth?.user?.id),
        });

        pushDataLayerEvent(
          "refund",
          {
            user_data: refundUserData,
            ...buildGtmEventFields({
              language: i18n.language,
              user: auth?.user,
              booking: trackingBooking,
              flypros: trackingBooking?.therapists,
            }),
            ecommerce: buildEcommerceObject({
              currency,
              transactionId,
              value: refundedDelta,
              tax: computeTaxFromTtc(refundedDelta),
              paymentType: paymentMethod,
              items,
            }),
          },
          {
            dedupeKey: createEventDedupeKey("refund", transactionId, refundedAfter),
          }
        );
        return;
      }

      if (attempt < 2) {
        await delay(1500);
      }
    }
  };

  const showCancelModal = (booking) => {
    const now = new Date();
    const start = new Date(booking.start_before);
    const diffInHours = (start - now) / (1000 * 60 * 60);

    setCancelBookingId(booking.id);
    setCancelSuccessMessage("");
    setDiffInHour(diffInHours);

    // Check for offline payment first
    if (booking.offline_payment) {
      const hasOnlinePayments = hasOnlineTransactions(booking);
      
      if (hasOnlinePayments) {
        // Offline booking with online extensions - show partial refund info
        setCancelMessage(t('offline_partial_refund_message', 'Cette commande a été payée partiellement hors ligne. Seuls les paiements en ligne peuvent être remboursés.'));
        setShowOfflineConfirmation(false);
        setCancelChoicePhase(diffInHours >= 24 && diffInHours <= 120);
      } else {
        // Pure offline booking - no refund possible
        setCancelMessage(t('offline_payment_cancellation_message', 'Cette commande a été payée hors ligne. L\'annulation ne donnera lieu à aucun remboursement automatique.'));
        setShowOfflineConfirmation(true);
        setCancelChoicePhase(false);
      }
      setShowCancelConfirm(true);
      return;
    }

    // Regular cancellation logic for online payments
    let message = "";
    if (diffInHours < 24) {
      message = t('cancel_w_24');
      setCancelChoicePhase(false);
    } else if (diffInHours >= 24 && diffInHours <= 120) {
      message = t('cancel_b_24_5');
      setCancelChoicePhase(true);
    } else {
      message = t('cancel_l_5');
      setCancelChoicePhase(false);
    }

    setShowOfflineConfirmation(false);
    setCancelMessage(message);
    setShowCancelConfirm(true);
  };

  const getStatusBadge = (status) => {
    const map = {
      CREATED: { label: 'CREATED', bg: '#e0e0e0', fg: '#616161' },
      PENDING_ACKNOWLEDGEMENT: { label: 'PENDING ACKNOWLEDGEMENT', bg: '#fff3cd', fg: '#ff9800' },
      PENDING_SECOND_ACKNOWLEDGEMENT: { label: 'PENDING 2ND ACK', bg: '#fff3cd', fg: '#ff9800' },
      ACKNOWLEDGED: { label: 'ACKNOWLEDGED', bg: '#d6e4ff', fg: '#2196f3' },
      IN_TRANSIT: { label: 'IN TRANSIT', bg: '#d6e4ff', fg: '#2196f3' },
      STARTED: { label: 'STARTED', bg: '#e3e2ff', fg: '#3f51b5' },
      REACHED: { label: 'REACHED', bg: '#e3e2ff', fg: '#3f51b5' },
      COMPLETED: { label: 'COMPLETED', bg: '#d4f8d4', fg: '#28a745' },
      PAID: { label: 'PAID', bg: '#ccf8cb', fg: '#29a233' },
      PROCESSING_PAYMENT: { label: 'PROCESSING PAYMENT', bg: '#d6e4ff', fg: '#2196f3' },
      FAILED_PAYMENT: { label: 'PAYMENT FAILED', bg: '#fde4e4', fg: '#f44336' },
      DECLINED: { label: 'PENDING', bg: '#d6e4ff', fg: '#2196f3' },
      FAILED: { label: 'FAILED', bg: '#fde4e4', fg: '#f44336' },
      CANCELED: { label: 'CANCELED', bg: '#fde4e4', fg: '#f44336' },
      UPDATED: { label: 'UPDATED', bg: '#f3e5f5', fg: '#9c27b0' },
    };
    return map[status] || { label: status, bg: '#e0e0e0', fg: '#616161' };
  };

  const showWalleeLightbox = (scriptUrl, paymentUrl, onSuccess) => {
    // Si le handler existe déjà, on démarre directement le loader et la lightbox
    if (window.LightboxCheckoutHandler) {
      loader.start();
      window.LightboxCheckoutHandler.startPayment(paymentUrl, () => {
        loader.stop();
        onSuccess();
      });
      return;
    }

    // Sinon, on télécharge le script Wallee en affichant le loader
    loader.start();
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      // Une fois le script chargé, on démarre la lightbox
      window.LightboxCheckoutHandler.startPayment(paymentUrl, () => {
        loader.stop();
        onSuccess();
      });
    };
    document.body.appendChild(script);
  };

  const fetchProlongationProducts = async (booking) => {
    try {
      const currentDuration = booking.products.reduce((sum, p) => sum + (p.duration || 0), 0);

      const productsResp = await ProductService.index({
        category_id: booking.products[0].category_id,
        is_active: 1,
        is_hidden: false
      }, api);

      const productsData = Array.isArray(productsResp) ? productsResp : (productsResp?.data || []);
      const visibleProductsData = productsData.filter(p => !!p.is_active && !p.is_hidden);

      const sortedProducts = [...visibleProductsData].sort((a, b) => a.duration - b.duration);

      const filteredProducts = sortedProducts
        .map(p => ({
          ...p,
          _diffDuration: p.duration - currentDuration
        }))
        .filter(p => p._diffDuration > 0);

      setAvailableProducts(filteredProducts);
      setSelectedBooking(booking);

      const bookingEndTime = getExtendedEndTime(booking.start_before, currentDuration);
      setExtendedEndTime(null);
      setOriginalEndTime(bookingEndTime);
      setSelectedProductToAdd(null);

      setShowProlongationModal(true);
    } catch (error) {
      notify.error(t('commande:prolongation.error_loading_produts'));
    }
  };

  const handleProlongation = async () => {
    if (!selectedBooking) return;

    if (!selectedProductToAdd) {
      setProlongationErrorMessage(t('commande:prolongation.error_duration_required'));
      return;
    }

    loader.start();
    setIsProcessingChange(true);
    setErrorMessage(''); // clear previous errors
    setProlongationErrorMessage("");

    try {
      const oldProduct = selectedBooking.products[0];
      const oldDuration = Number(oldProduct.duration);
      const diff = parseInt(selectedProductToAdd._diffDuration, 10);
      const newTargetDuration = oldDuration + diff;

      const productsResp = await ProductService.index({
        category_id: oldProduct.category_id,
        is_active: 1,
        is_hidden: false,
      }, api);

      const productsData2 = Array.isArray(productsResp) ? productsResp : (productsResp?.data || []);
      const visibleProductsData2 = productsData2.filter(p => !!p.is_active && !p.is_hidden);

      const newProduct = visibleProductsData2.find(p => Number(p.duration) === newTargetDuration);

      if (!newProduct) {
        setErrorMessage(t('commande:prolongation.no_product_found'));
        loader.stop();
        return;
      }

      const pendingBookingPayload = {
        products: [newProduct.id],
        duration: parseInt(newProduct.duration, 10),
        total_fare: newProduct.price,
        subtotal: newProduct.price,
        therapists: selectedBooking?.therapists?.map(t => t.id),
        locale: i18n.language,
      };

      const payResponse = await BookingService.payDifference(
        {
          booking_id: selectedBooking.id,
          new_total: newProduct.price,
          checkAvailibility: true,
          duration: newProduct.duration,
          success_update: pendingBookingPayload,
          locale: i18n.language,
        },
        api
      );

      const lightboxUrl = payResponse.transaction_data?.data?.payment_lightbox;
      const paymentUrl = payResponse.transaction_data?.data?.payment_url;

      if (lightboxUrl && paymentUrl) {
        showWalleeLightbox(lightboxUrl, paymentUrl, () => {
          navigate("/commande");
          loader.stop();
        });
      } else {
        loader.stop();
      }

    } catch (err) {
      console.error(t('commande:prolongation.error_extension'), err);

      // response message
      const backendMessage = err?.response?.data?.message;

      if (backendMessage?.includes("therapist is not available")) {
        setErrorMessage(t('commande:prolongation.error_unavailable_duration'));
      } else if (backendMessage) {
        setErrorMessage(backendMessage);
      } else {
        setErrorMessage(t('commande:prolongation.error_prolongation'));
      }
      loader.stop();
    } finally {
      setIsProcessingChange(false);
    }
  };

  function getBookingEnd(booking) {
    // check for dates
    if (!booking.start_before || !booking.duration) return new Date(0);
    return new Date(new Date(booking.start_before).getTime() + booking.duration * 60000);
  }

  function sortBookings(bookings) {
    const now = new Date();

    const upcoming = [];
    const past = [];

    bookings.forEach(b => {
      const end = getBookingEnd(b);
      if (end >= now) {
        upcoming.push(b);
      } else {
        past.push(b);
      }
    });

    // Upcoming bookings
    upcoming.sort((a, b) => getBookingEnd(a) - getBookingEnd(b));
    // Past bookings
    past.sort((a, b) => getBookingEnd(b) - getBookingEnd(a));

    return [...upcoming, ...past];
  }

  return (
    <>

      <MenuHeader />
      <div className="content-wrapper commande-page">
        <div className="content-wrapper duo-pay commande-page__list">

          {!isEditing && sortBookings(bookings).map((booking) => {
            const isCompleted = booking.status === "COMPLETED";
            if (booking.isDuo && booking.therapists.length > 1 || booking.products.length === 4) {
              return (
                <div key={booking.id} className={`duo-card ${booking.status === "CANCELED" ? "cancelled-card" : ""}`}>
                  {booking.therapists.map((therapist, index) => (
                    <div
                      key={`${booking.id}-${therapist.id}`}
                      className={`column duo-col ${booking.status === "PENDING_ACKNOWLEDGEMENT" ? "card-disabled" : ""} ${booking.status === "CANCELED" ? "cancelled-card" : ""}`}
                    >
                      <div
                        className="summary-box"
                        onClick={() => {
                          const rawBooking = combinedBookings.find(b => b.id === booking.id);
                          navigate('/details', {
                            state: { booking: rawBooking, therapist, products: rawBooking.products },
                          });
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {(() => {

                          const { label, bg, fg } = getStatusBadge(booking.status);
                          return (
                            <span
                              className="status-badge"
                              style={{
                                backgroundColor: bg,
                                color: fg,
                                position: 'absolute',
                                top: 12,
                                right: 12,
                              }}
                            >
                              {t(`status.${booking.status}`)}
                            </span>
                          );
                        })()}
                        {therapist && (
                          <div className="name">
                            <div
                              className="image"
                              style={{ backgroundImage: `url(${therapist.media.length ? therapist.media[0].original_url : "assets/images/icon-pro.svg"})` }}
                            />
                            <div className="title">
                              <div className="text-wrapper-2">{therapist.firstname}</div>
                              <div className="rating">
                                <div className="stars">
                                  <div className="text-wrapper-3">
                                    <img className="https-app" src={star2} alt={t('rating_alt')} />
                                  </div>
                                </div>
                                <div className="text-wrapper-4">
                                  {therapist.extra?.rating ? (Number.isInteger(therapist.extra.rating) ? therapist.extra.rating : therapist.extra.rating.toFixed(1)) : "5"}/5
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {(() => {
                          const isSingleTherapist = (booking.therapists?.length || 0) <= 1;

                          const therapistProducts = isSingleTherapist
                            ? booking.products
                            : (booking.products.length === 4
                              ? booking.products.slice(index * 2, index * 2 + 2)
                              : [booking.products[index]]);

                          return therapistProducts.filter(Boolean).map((product, pIndex) => (
                            <React.Fragment key={`${booking.id}-product-${index}-${pIndex}`}>
                              <div className="div-2">
                                <div className="text-wrapper-5">{product?.category?.title} - {product?.duration} min</div>                              </div>

                              <div className="div-2">
                                <p className="text-wrapper-5">
                                  {formatHistoryCardDate(booking.start_before)}{" "}
                                  {
                                    new Date(booking.start_before).toLocaleTimeString("fr-FR", {
                                      timeZone: "Europe/Zurich",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    }).slice(0, 5)
                                  }{" - "}
                                  {
                                    addMinutesToTime(
                                      new Date(booking.start_before).toLocaleTimeString("fr-FR", {
                                        timeZone: "Europe/Zurich",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: false,
                                      }).slice(0, 5),
                                      Number(product?.duration)
                                    )
                                  }
                                </p>
                                <div className="text-wrapper-6">{product?.price} CHF</div>
                              </div>
                            </React.Fragment>
                          ));
                        })()}

                        <div className="div-2">
                          <p className="text-wrapper-5">
                            {booking.address?.street} {booking.address?.street_number}
                            <br />
                            {booking.address?.zip_code} {booking.address?.state}
                            <br />
                            {booking.phone}
                          </p>
                        </div>

                        {!booking.ratings?.[0]?.rating && (() => {
                          const canReview =
                            booking.status === 'COMPLETED' &&
                            new Date(booking.start_before).getTime() < Date.now();
                          const start = new Date(booking.start_before);
                          const now = new Date();
                          const isFutureDateTime = start > now;
                          const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                          const todayDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                          const isFutureDay = startDay > todayDay;
                          const canEdit = isFutureDateTime && isFutureDay;
                          const canCancel = isFutureDateTime;
                          return (
                            <>
                              <button
                                style={{ display: canReview ? 'inline-block' : 'none' }}
                                className="review-button"
                                onClick={() => openModal(therapist, booking.id)}
                              >
                                <img src="/assets/images/trash-alt.png" alt={t('evaluate_flypro_alt')} className="review-icon" />
                                {t('commande:evaluate_your_flypro')}
                              </button>

                              {/* Modifier / Details / Annuler: FIRST column only */}
                              {(
                                <>
                                  <div style={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '100%'
                                  }}>
                                    {['FAILED', 'PROCESSING_PAYMENT'].includes(booking.status) ? (
                                      <ThemeProvider theme={theme}>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                          <Button
                                            variant="outlined"
                                            color="dark"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                              navigate('/details', {
                                                state: {
                                                  booking: rawBooking,
                                                  therapist,
                                                  products: rawBooking.products
                                                },
                                              });
                                            }}
                                            sx={{
                                              textTransform: 'none',
                                              borderRadius: '15px',
                                              width: '100%',
                                              minWidth: '180px',
                                              minHeight: '50px',
                                            }}
                                          >
                                            {t('commande:details')}
                                          </Button>
                                        </div>
                                      </ThemeProvider>
                                    ) : (
                                      <>
                                        {index === 0 ? (
                                          <ThemeProvider theme={theme}>
                                            {/* Modifier + Details in a row */}
                                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                              {canEdit && (
                                                <Button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                                    setBookingToEdit(rawBooking);
                                                    setIsEditing(true);
                                                  }}
                                                  variant="contained"
                                                  color="dark_yellow"
                                                  sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '15px',
                                                    width: '100%',
                                                    minWidth: '180px',
                                                    minHeight: '50px',
                                                  }}
                                                >
                                                  {t('commande:modify')}
                                                </Button>
                                              )}
                                              <Button
                                                variant="outlined"
                                                color="dark"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  e.preventDefault();
                                                  const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                                  navigate('/details', {
                                                    state: { booking: rawBooking, therapist, products: rawBooking.products },
                                                  });
                                                }}
                                                sx={{
                                                  textTransform: 'none',
                                                  borderRadius: '15px',
                                                  width: '100%',
                                                  minWidth: '180px',
                                                  minHeight: '50px',
                                                }}
                                              >
                                                {t('commande:details')}
                                              </Button>
                                            </div>
                                            {/* Annuler below */}
                                            {canCancel && (
                                              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                <button
                                                  className="cancel-button"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    showCancelModal(booking);
                                                  }}
                                                  style={{
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    padding: '12px 20px',
                                                    borderRadius: '12px',
                                                    fontWeight: 'bold',
                                                    minWidth: '200px',
                                                    maxWidth: '280px',
                                                  }}
                                                >
                                                  {t('commande:annuller')}
                                                </button>
                                              </div>
                                            )}
                                          </ThemeProvider>
                                        ) : (
                                          // index !== 0
                                          <ThemeProvider theme={theme}>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                              <Button
                                                variant="outlined"
                                                color="dark"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  e.preventDefault();
                                                  const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                                  navigate('/details', {
                                                    state: {
                                                      booking: rawBooking,
                                                      therapist,
                                                      products: rawBooking.products
                                                    },
                                                  });
                                                }}
                                                sx={{
                                                  textTransform: 'none',
                                                  borderRadius: '15px',
                                                  width: '100%',
                                                  minWidth: '180px',
                                                  minHeight: '50px',
                                                }}
                                              >
                                                {t('commande:details')}
                                              </Button>
                                            </div>
                                          </ThemeProvider>
                                        )}
                                      </>
                                    )}


                                  </div >

                                  {/* {index === 0 && canCancel && !isActionDisabled && (
                                    <div
                                      style={{
                                        marginTop: '20px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                      }}
                                    >
                                      <button
                                        className="cancel-button"
                                        onClick={() => showCancelModal(booking)}
                                        style={{
                                          backgroundColor: 'red',
                                          color: 'white',
                                          padding: '12px 20px',
                                          borderRadius: '12px',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {t('commande:annuller')}
                                      </button>
                                    </div>
                                  )
                                  } */}
                                </>
                              )}
                            </>
                          );
                        })()}

                      </div>
                    </div>
                  ))}
                </div>
              );
            } else {
              // Single therapist booking
              const therapist = booking.therapists[0];
              const start = new Date(booking.start_before);
              const now = new Date();
              // const end = new Date(booking.start_before).getTime() + booking.duration * 60 * 1000;
              // const isFutureDateTime = end < now;
              const isFutureCancelDateTime = start > now;
              const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
              const todayDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
              // const isFutureDay = startDay > todayDay;
              // const canEdit = isFutureDateTime && isFutureDay;
              const canCancel = isFutureCancelDateTime;
              return (
                <div key={`${booking.id}-${therapist?.id}`} className={`column ${booking.status === "PENDING_ACKNOWLEDGEMENT" ? "card-disabled" : ""} ${booking.status === "CANCELED" ? "cancelled-card" : ""}`}>
                  <div className={`summary-box ${booking.status === "COMPLETED" ? "completed-booking" : ""} ${booking.status === "CANCELED" ? "cancelled-card" : ""}`} style={{ position: 'relative', cursor: 'pointer' }}
                    onClick={() => {
                      const rawBooking = combinedBookings.find(b => b.id === booking.id);
                      navigate('/details', {
                        state: { booking: rawBooking, therapist, products: rawBooking.products },
                      });
                    }}>
                    {(() => {
                      const { label, bg, fg } = getStatusBadge(booking.status);
                      return (
                        <>
                          <span
                            className="status-badge"
                            style={{
                              backgroundColor: bg,
                              color: fg,
                              position: 'absolute',
                              top: 12,
                              right: 12,
                            }}
                          >
                            {t(`status.${booking.status}`)}
                          </span>
                        </>
                      );
                    })()}
                    {booking.status === "FAILED_PAYMENT" && (
                      <Button
                        variant="outlined"
                        color="dark"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handlePayment(booking);
                        }} sx={{
                          textTransform: 'none',
                          borderRadius: '15px',
                          // width: '100%',
                          // minWidth: '180px',
                          maxHeight: '24px',
                        }}
                      >
                        {t('proceed_payment')}
                      </Button>
                    )}
                    {therapist && (
                      <div className="name">
                        <div
                          className="image"
                          style={{ backgroundImage: `url(${therapist.media.length ? therapist.media[0].original_url : "assets/images/icon-pro.svg"})` }}
                        />
                        <div className="title">
                          <div className="text-wrapper-2">{therapist.firstname}</div>
                          <div className="rating">
                            <div className="stars">
                              <div className="text-wrapper-3">
                                <img className="https-app" src={star2} alt={t('rating_alt')} />
                              </div>
                            </div>
                            <div className="text-wrapper-4">
                              {therapist.extra?.rating ? (Number.isInteger(therapist.extra.rating) ? therapist.extra.rating : therapist.extra.rating.toFixed(1)) : "5"}/5
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="div-2">
                      <div className="text-wrapper-5">{booking.products?.map((prod, index) => (
                        <div key={index}>
                          {prod?.category?.title} - {prod?.duration} min</div>
                      ))}</div>
                    </div>

                    <div className="div-2">
                      <p className="text-wrapper-5">
                        {formatHistoryCardDate(booking.start_before)}{" "}
                        {
                          (() => {
                            const zurichTime = new Date(booking.start_before).toLocaleTimeString("fr-FR", {
                              timeZone: "Europe/Zurich",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            });
                            const [hour, minute] = zurichTime.split(":");
                            return `${hour}:${minute} - ${addMinutesToTime(`${hour}:${minute}`, booking.duration)}`;
                          })()
                        }
                      </p>
                      <div className="text-wrapper-6">{booking.subtotal} CHF</div>

                    </div>

                    <div className="div-2">
                      <p className="text-wrapper-5">
                        {booking.address?.street} {booking.address?.street_number}
                        <br />
                        {booking.address?.zip_code} {booking.address?.state}
                        <br />
                        {booking.phone}
                      </p>
                    </div>

                    {!booking.ratings?.[0]?.rating && (() => {
                      const isDisabled = new Date(booking.start_before).getTime() > Date.now();
                      return (
                        <>
                          {booking.status === 'COMPLETED' && (
                            <button
                              className="review-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                openModal(therapist, booking.id)
                              }}
                            >
                              <img src="/assets/images/trash-alt.png" alt={t('evaluate_flypro_alt')} className="review-icon" />
                              {t('commande:evaluate_your_flypro')}
                            </button>

                          )}
                          {/* {booking.status !== 'CANCELED' && ( */}
                          <>
                            <div style={{
                              display: 'flex', flexDirection: 'column', alignItems: 'center',
                              height: '100%'
                              , width: '100%'
                            }}>
                              <ThemeProvider theme={theme}>
                                {/* Row with Modifier and Details buttons */}
                                <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                  {/* {booking.status !== 'CANCELED' && (
                                    <Button
                                      onClick={() => {
                                        setBookingToEdit(booking);
                                        setIsEditing(true);
                                      }}
                                      variant="contained"
                                      color="dark_yellow"
                                      sx={{
                                        textTransform: 'none',
                                        borderRadius: '15px',
                                        width: '100%',
                                        minWidth: '180px',
                                        minHeight: '50px',
                                      }}
                                    >
                                      {t('commande:modify')}
                                    </Button>
                                  )} */}
                                  {booking.status !== 'CANCELED' && (
                                    <>
                                      <div style={{
                                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                                        height: '100%'
                                        , width: '100%'
                                      }}>
                                        {['FAILED', 'PROCESSING_PAYMENT', 'COMPLETED'].includes(booking.status) ? (
                                          // Display only Details button
                                          <ThemeProvider theme={theme}>
                                            {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                              <Button
                                                variant="outlined"
                                                color="dark"
                                                onClick={() => {
                                                  navigate('/details', {
                                                    state: { booking, therapist, products: booking.products },
                                                  });
                                                }}
                                                sx={{
                                                  textTransform: 'none',
                                                  borderRadius: '15px',
                                                  width: '100%',
                                                  minWidth: '180px',
                                                  minHeight: '50px',
                                                }}
                                              >
                                                {t('commande:details')}
                                              </Button>
                                            </div> */}
                                          </ThemeProvider>
                                        ) : (
                                          // Display Modify, Extend, Details, Cancel buttons
                                          <ThemeProvider theme={theme}>
                                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
                                              {(() => {
                                                const start = new Date(booking.start_before).getTime();
                                                const end = start + booking.duration * 60 * 1000;
                                                const now = Date.now();
                                                const showProlonger = now >= start - 24 * 60 * 60 * 1000 && now <= end;
                                                const showModifier = now < end - 24 * 60 * 60 * 1000;

                                                return (
                                                  <>
                                                    {(showModifier && booking.status !== "FAILED_PAYMENT") && (
                                                      <Button
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          e.preventDefault();
                                                          const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                                          setBookingToEdit(rawBooking);
                                                          setIsEditing(true);
                                                        }}
                                                        variant="contained"
                                                        color="dark_yellow"
                                                        sx={{
                                                          textTransform: 'none',
                                                          borderRadius: '15px',
                                                          width: '100%',
                                                          minWidth: '180px',
                                                          minHeight: '50px',
                                                        }}
                                                      >
                                                        {t('commande:modify')}
                                                      </Button>
                                                    )}

                                                    {showProlonger && (
                                                      <Button
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          e.preventDefault();
                                                          setSelectedBooking(booking);
                                                          fetchProlongationProducts(booking);
                                                        }}
                                                        variant="contained"
                                                        color="dark_yellow"
                                                        sx={{
                                                          textTransform: 'none',
                                                          borderRadius: '15px',
                                                          width: '100%',
                                                          minWidth: '180px',
                                                          minHeight: '50px',
                                                        }}
                                                      >
                                                        {t('commande:prolongation_button')}
                                                      </Button>
                                                    )}
                                                  </>
                                                );
                                              })()}

                                              <Button
                                                variant="outlined"
                                                color="dark"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  e.preventDefault();
                                                  const rawBooking = combinedBookings.find(b => b.id === booking.id);
                                                  navigate('/details', {
                                                    state: {
                                                      booking: rawBooking,
                                                      therapist,
                                                      products: rawBooking.products
                                                    },
                                                  });
                                                }}
                                                sx={{
                                                  textTransform: 'none',
                                                  borderRadius: '15px',
                                                  width: '100%',
                                                  minWidth: '180px',
                                                  minHeight: '50px',
                                                }}
                                              >
                                                {t('commande:details')}
                                              </Button>
                                            </div>

                                            {canCancel && booking.status !== 'COMPLETED' && booking.status !== "FAILED_PAYMENT" && (
                                              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                <button
                                                  className="cancel-button"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    showCancelModal(booking)
                                                  }}
                                                  style={{
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    padding: '12px 20px',
                                                    borderRadius: '12px',
                                                    fontWeight: 'bold',
                                                  }}
                                                >
                                                  {t('commande:annuller')}
                                                </button>
                                              </div>
                                            )}
                                          </ThemeProvider>
                                        )}

                                      </div>

                                      {/* <Button
                                        variant="outlined"
                                        color="dark"
                                        onClick={() => {
                                          navigate('/details', {
                                            state: {
                                              booking,
                                              therapist,
                                              products: booking.products,
                                            },
                                          });
                                        }}
                                        sx={{
                                          textTransform: 'none',
                                          borderRadius: '15px',
                                          width: '100%',
                                          minWidth: '180px',
                                          minHeight: '50px',
                                        }}
                                      >
                                        {t('commande:details')}
                                      </Button> */}
                                    </>
                                  )}
                                  {/* Centered Annuler button below */}
                                  {/* {booking.status !== 'CANCELED' && canCancel && (
                                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                      <button
                                        className="cancel-button"
                                        onClick={() => showCancelModal(booking)}
                                        style={{
                                          backgroundColor: 'red',
                                          color: 'white',
                                          padding: '12px 20px',
                                          borderRadius: '12px',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {t('commande:annuller')}
                                      </button>
                                    </div>
                                  )} */}
                                </div>
                              </ThemeProvider>
                            </div>

                          </>
                          {/* )} */}

                        </>
                      );

                    })()
                    }
                    {booking.status === 'COMPLETED' && (
                      <Button
                        variant="outlined"
                        color="dark"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          const rawBooking = combinedBookings.find(b => b.id === booking.id);
                          navigate('/details', {
                            state: {
                              booking: rawBooking,
                              therapist,
                              products: rawBooking.products,
                            },
                          });
                        }}
                        sx={{
                          textTransform: 'none',
                          borderRadius: '15px',
                          width: '100%',
                          minWidth: '180px',
                          minHeight: '50px',
                        }}
                      >
                        {t('commande:details')}
                      </Button>
                    )}
                  </div>
                </div>
              );
            }
          })}
          {loading && !isEditing && (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p>{t('loading_more_bookings')}</p>
            </div>
          )}

          {!hasMore && !isEditing && (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p>{t('no_more_bookings')}</p>
            </div>
          )}


          {isEditing && bookingToEdit && (
            <div className="form">
              <CommandeEdit
                key={`${bookingToEdit?.id}-${editRefreshNonce}`}
                booking={bookingToEdit}
                bookingToEdit={bookingToEdit}
                onBack={() => {
                  setBookingToEdit(null);
                  setIsEditing(false);
                }}
                onUpdate={(updatedBooking) => {
                  console.log("Updated booking:", updatedBooking);
                  setBookingToEdit(null);
                  setIsEditing(false);
                  fetchBookings();
                }}
              />

            </div>
          )}
        </div >
      </div >

      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} className="review-modal">
        <button className="close-button-evaluer" onClick={closeModal}>
          <span className="close-icon">✖</span>
        </button>

        <div className="evaluation-pro">
          {t('commande:evaluate_your_flypro')}</div>

        <div className="therapist-review-details">
          <img src={!selectedTherapist?.media?.length ? "assets/images/icon-pro.svg" : selectedTherapist?.media[0].original_url} alt={t('therapist_alt')} className="therapist-image" />
          <span className="therapist-name">
            {selectedTherapist?.firstname}
            <br />
            <img src={star2} />{" "}
            {selectedTherapist?.extra?.rating
              ? (Number.isInteger(selectedTherapist.extra.rating)
                ? selectedTherapist.extra.rating
                : selectedTherapist.extra.rating.toFixed(1))
              : "5"}/5
          </span>
        </div>
        <form onSubmit={handleSubmitReview}>
          <label>{t('commande:note')}</label>
          <div className="formField margin-top">
            <CustomRating
              name="custom-rating"
              precision={0.5}
              value={rating}
              onChange={(event, newValue) => setRating(newValue)}
              size="large"
              icon={<img src="/assets/images/star-sharp.png" alt={t('filled_star_alt')} />}
            />
          </div>

          <div className="comment-section">
            <label>{t('commande:comment')}</label>
            <textarea
              placeholder={t('message')}
              value={comment}
              className="textformarea margin-top"
              onChange={(e) => setComment(e.target.value)}
            />
          </div>

          <button className="btn-submit" type="submit">
            {t('commande:validate')}
          </button>
        </form>
      </Modal>

      <Modal isOpen={successModalIsOpen} onRequestClose={() => setSuccessModalIsOpen(false)} style={customStyles} className="review-modal">
        <button className="close-button-evaluer" onClick={() => setSuccessModalIsOpen(false)}>
          <span className="close-icon">✖</span>
        </button>

        <div className="success-message-container">
          <span className="success-check">✔</span>
          <span className="success-message">{t('commande:thank_you_for_your_review')}</span>
        </div>
      </Modal>

      <Modal
        isOpen={showCancelConfirm}
        onRequestClose={() => setShowCancelConfirm(false)}
        className="cancel-confirm-modal"
        style={{
          content: {
            width: "90%",
            maxWidth: "440px",
            maxHeight: "350px",
            margin: "auto",
            padding: "30px",
            borderRadius: "12px",
            textAlign: "center"
          }
        }}
      >
        {!cancelSuccessMessage ? (
          <>
            <h2>{t('cancel_title')}</h2>
            <p style={{ marginTop: '20px' }}>{cancelMessage}</p>
            <a
              href="https://flyspa.ch/conditions-annulation/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '14px', textDecoration: 'underline', display: 'block', marginTop: '10px' }}
            >
              {t('cancel_condition')}
            </a>
            {(() => {
              const currentBooking = combinedBookings.find(b => b.id === cancelBookingId);
              return currentBooking?.offline_payment && hasOnlineTransactions(currentBooking) && !showOfflineConfirmation && (
                <div style={{ 
                  marginTop: "16px", 
                  padding: "12px", 
                  backgroundColor: "#fff3cd", 
                  borderLeft: "4px solid #ffc107",
                  borderRadius: "4px",
                  fontSize: "13px",
                  textAlign: "left"
                }}>
                  <p style={{ marginBottom: "6px", color: "#856404", fontWeight: "bold" }}>
                    ⚠️ {t('partial_refund_title', 'Remboursement Partiel')}
                  </p>
                  <p style={{ marginBottom: "0", color: "#856404", lineHeight: "1.4" }}>
                    {t('partial_refund_notice', 'Ce paiement hors ligne a été étendu avec des paiements en ligne. Seuls les montants payés en ligne pourront être remboursés.')}
                  </p>
                </div>
              );
            })()}

            {(() => {
              const currentBooking = combinedBookings.find(b => b.id === cancelBookingId);
              return currentBooking?.offline_payment && !hasOnlineTransactions(currentBooking) && !showOfflineConfirmation && (
                <div style={{ 
                  marginTop: "16px", 
                  padding: "12px", 
                  backgroundColor: "#f8d7da", 
                  borderLeft: "4px solid #dc3545",
                  borderRadius: "4px",
                  fontSize: "13px",
                  textAlign: "left"
                }}>
                  <p style={{ marginBottom: "6px", color: "#721c24", fontWeight: "bold" }}>
                    ❌ {t('no_refund_title', 'Aucun Remboursement')}
                  </p>
                  <p style={{ marginBottom: "0", color: "#721c24", lineHeight: "1.4" }}>
                    {t('no_refund_offline', 'Ce paiement a été effectué hors ligne et ne peut pas être remboursé automatiquement.')}
                  </p>
                </div>
              );
            })()}

            {showOfflineConfirmation ? (
              // Offline payment confirmation modal
              <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                <ThemeProvider theme={theme}>
                  <Button
                    onClick={handleOfflinePaymentCancel}
                    variant="contained"
                    color="dark_yellow"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '15px',
                      width: '100%',
                      minWidth: '180px',
                      minHeight: '50px',
                    }}
                  >
                    {t('confirm_cancellation', 'Confirmer l\'annulation')}
                  </Button>
                  <Button
                    onClick={() => setShowCancelConfirm(false)}
                    variant="contained"
                    color="dark_grey"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '15px',
                      width: '100%',
                      minWidth: '180px',
                      minHeight: '50px',
                    }}
                  >
                    {t('cancel_button')}
                  </Button>
                </ThemeProvider>
              </div>
            ) : cancelChoicePhase ? (
              <>
                <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                  <ThemeProvider theme={theme}>

                    <Button
                      onClick={() => handleCancelBooking('FLATT_OFF')}
                      variant="contained"
                      color="dark_yellow"
                      sx={{
                        textTransform: 'none',
                        borderRadius: '15px',
                        width: '100%',
                        minWidth: '180px',
                        minHeight: '50px',
                      }}
                    >
                      {t('cancel_promo')}
                    </Button>
                    <Button
                      onClick={() => handleCancelBooking('FULL_REFUND')}
                      variant="contained"
                      color="dark_yellow"
                      sx={{
                        textTransform: 'none',
                        borderRadius: '15px',
                        width: '100%',
                        minWidth: '180px',
                        minHeight: '50px',
                      }}
                    >
                      {t('cancel_refund')}
                    </Button>
                  </ThemeProvider>
                </div>
                <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                  <ThemeProvider theme={theme}>
                    <Button
                      onClick={() => setShowCancelConfirm(false)}
                      variant="contained"
                      color="dark_grey"
                      sx={{
                        textTransform: 'none',
                        borderRadius: '15px',
                        width: '100%',
                        minWidth: '180px',
                        minHeight: '50px',
                      }}
                    >
                      {t('cancel_button')}
                    </Button>
                  </ThemeProvider>
                </div>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                <ThemeProvider theme={theme}>
                  <Button
                    onClick={() => handleCancelBooking('FULL_REFUND')}
                    variant="contained"
                    color="dark_yellow"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '15px',
                      width: '100%',
                      minWidth: '180px',
                      minHeight: '50px',
                    }}
                  >
                    {t('continue_button')}
                  </Button>
                  <Button
                    onClick={() => setShowCancelConfirm(false)}
                    variant="contained"
                    color="dark_grey"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '15px',
                      width: '100%',
                      minWidth: '180px',
                      minHeight: '50px',
                    }}
                  >
                    {t('close_button')}
                  </Button>
                </ThemeProvider>
              </div>
            )}
          </>
        ) : (
          <>
            <h2>{t('cancel_message')}</h2>
            <p style={{ marginTop: '20px' }}>{cancelSuccessMessage}</p>
            <button
              onClick={() => { setShowCancelConfirm(false); window.location.reload(); }}
              style={{
                marginTop: "24px",
                padding: "12px 28px",
                backgroundColor: "#393d44",
                color: "#faef9b",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer"
              }}
            >
              {t('close_button')}
            </button>
          </>
        )}
      </Modal>

      <Modal
        isOpen={showProlongationModal}
        onRequestClose={() => {
          setShowProlongationModal(false);
          setSelectedProductToAdd(null);
          setExtendedEndTime(null);
          setErrorMessage('');
          setProlongationErrorMessage("");
        }}
        style={{
          content: {
            width: "90%",
            maxWidth: "440px",
            margin: "auto",
            padding: "25px",
            borderRadius: "20px",
            textAlign: "center",
            inset: '50% auto auto 50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
            fontFamily: 'Lato',
            backgroundColor: '#fff',
          }
        }}
      >
        <IconButton
          onClick={() => {
            setShowProlongationModal(false);
            setSelectedProductToAdd(null);
            setExtendedEndTime(null);
            setErrorMessage('');
            setProlongationErrorMessage("");
          }
          }
          aria-label={t('close')}
          style={{
            position: 'absolute',
            top: 10,
            left: 5,
            zIndex: 10
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        {/* Title */}
        <h2 style={{
          fontFamily: 'Marcellus',
          fontWeight: 400,
          fontSize: '18px',
          marginBottom: '25px',
          textAlign: 'center',
          color: '#393D44'
        }}>
          {t('commande:prolongation.title')}
        </h2>

        {errorMessage && (
          <div style={{ color: 'red', marginBottom: '10px', fontSize: '14px', textAlign: 'center' }}>
            {errorMessage}
          </div>
        )}

        {/* Duration Selector */}
        <div className="duration-selector-container">
          <div className="duration-selector">
            {availableProducts.length > 0 ? (
              availableProducts.map((p, index) => (
                <button
                  key={p.id}
                  className={`duration-button 
    ${selectedProductToAdd?.id === p.id ? 'selected' : ''}`}
                  onClick={() => {
                    const startISO = selectedBooking?.start_before;
                    const extraDuration = parseInt(p._diffDuration, 10);

                    if (!startISO || !extraDuration || isNaN(extraDuration)) {
                      console.warn(t('commande:prolongation.missing_start_before_or_extra_duration'));
                      return;
                    }

                    setSelectedProductToAdd(p);

                    const newEndTime = new Date(originalEndTime.getTime() + p._diffDuration * 60000);
                    setExtendedEndTime(newEndTime);
                  }}
                >
                  {p._diffDuration} min. +{Number(p.price - selectedBooking?.subtotal).toFixed(2)} CHF
                </button>
              ))
            ) : (
              <div style={{ color: '#aaa', padding: '10px 5px 10px 18px' }}>
                {t('commande:prolongation.no_prolongation_available')}
              </div>
            )}

          </div>
        </div>

        {/* Date / Time Box */}
        <div className="info-section">
          <div className="info-line">
            <span className="info-label">{t('commande:prolongation.date')}</span>
            <span className="info-value">
              {selectedBooking?.start_before
                ? formatDate(selectedBooking.start_before, i18n.language)
                : '—'}
            </span>
          </div>

          <div className="info-line">
            <span className="info-label">{t('commande:prolongation.start')}</span>
            <span className="info-value">
              {selectedBooking?.start_before
                ? formatTime(selectedBooking.start_before, i18n.language)
                : '—'}
            </span>
          </div>

          <div className="info-line">
            <span className="info-label">{t('commande:prolongation.end')}</span>
            <span className="info-value">
              {extendedEndTime ? (
                <>
                  {formatTime(extendedEndTime, i18n.language)}
                  <span className="info-extra">
                    +{selectedProductToAdd?._diffDuration} minutes
                  </span>
                </>
              ) : (
                '—'
              )}
            </span>
          </div>
        </div>

        {/* Bottom Buttons */}
        <ThemeProvider theme={theme}>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '12px', width: '100%' }}>
            <Button
              onClick={() => {
                setSelectedProductToAdd(null);
                setExtendedEndTime(null);
                setErrorMessage('');
                setProlongationErrorMessage("");
              }}
              variant="contained"
              color="dark_yellow"
              sx={{
                textTransform: 'none',
                borderRadius: '15px',
                width: '100%',
                minWidth: '180px',
                minHeight: '50px',
              }}
            >
              {t('commande:prolongation.reset')}
            </Button>

            <Button
              onClick={handleProlongation}
              variant="contained"
              color="dark_yellow"
              sx={{
                textTransform: 'none',
                borderRadius: '15px',
                width: '100%',
                minWidth: '180px',
                minHeight: '50px',
              }}
            >
              {t('commande:prolongation.validate')}
            </Button>
          </div>
          <div style={{ marginTop: "15px" }}>
            {prolongationErrorMessage && (
              <p style={{ color: "red", textAlign: "center", marginBottom: "10px" }}>
                {prolongationErrorMessage}
              </p>
            )}
          </div>
        </ThemeProvider>
      </Modal>
      <Modal
        isOpen={modalIsPaiementOpen}
        onRequestClose={closeModalPaiement}
        style={customStyles2}
        contentLabel="Paiement Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          <div className="modal">
            <p className="modal-text2" style={{ whiteSpace: 'pre-line' }}>
              {modalMessage}
            </p>
            <div className="modal-button-container">
              <button className="modal-ok-button" onClick={redirectToHome}>
                {t('ok')}
              </button>
              <button className="modal-cancel-button" onClick={closeModalPaiement}>
                {t('cancel_modal')}
              </button>
            </div>
          </div>
        </div>
      </Modal>

    </>
  );
}

export default Commande;
